import { createContext, useContext } from "solid-js";
import type { _Whitelabel } from ":public-dynamic/whitelabel";

export const AppFlavorContext = createContext<_Whitelabel.AppFlavor>();
export const hooks = {
  useAppFlavor: () => useContext(AppFlavorContext),
};
